import React from "react";
import { FeedbackToast } from "../styles";
import type { FeedbackState } from "../types";

interface Props {
	feedback: FeedbackState;
	onClose: () => void;
}

export default function Feedback({ feedback, onClose }: Props) {
	if (!feedback) return null;

	const icon = feedback.kind === "success" ? "fa fa-check-circle" : "fa fa-times-circle";

	return (
		<FeedbackToast kind={feedback.kind}>
			<i className={icon} />
			<span>{feedback.message}</span>
			<button
				onClick={onClose}
				style={{
					background: "transparent",
					border: "none",
					cursor: "pointer",
					color: "inherit",
					marginLeft: 8,
					padding: "0 4px",
					fontSize: "0.875rem",
				}}>
				<i className="fa fa-times" />
			</button>
		</FeedbackToast>
	);
}
